import { apiPrefix } from '~/api';
/**
 * Call "Get Chart Score" API.
 * @see https://github.com/ddradar/ddradar/tree/master/api/scores__id__style__diff--get/
 */
export function getChartScore($http, songId, playStyle, difficulty, scope) {
    const query = scope ? `?scope=${scope}` : '';
    return $http.$get(`${apiPrefix}/scores/${songId}/${playStyle}/${difficulty}${query}`);
}
/**
 * Call "Get User Scores" API.
 * @see https://github.com/ddradar/ddradar/tree/master/api/scores__uid/
 */
export function getUserScores($http, userId, playStyle, difficulty, level, clearLamp, rank) {
    const searchParams = new URLSearchParams();
    addParamIfDefined('style', playStyle);
    addParamIfDefined('diff', difficulty);
    addParamIfDefined('lv', level);
    addParamIfDefined('lamp', clearLamp);
    addParamIfDefined('rank', rank);
    return $http.$get(`${apiPrefix}/scores/${userId}`, {
        searchParams,
    });
    function addParamIfDefined(name, obj) {
        if (obj !== undefined)
            searchParams.set(name, obj.toString());
    }
}
/**
 * Call "Post Chart Score" API.
 * @see https://github.com/ddradar/ddradar/tree/master/api/scores__id__style__diff--post/
 */
export function postChartScore($http, songId, playStyle, difficulty, score) {
    return $http.$post(`${apiPrefix}/scores/${songId}/${playStyle}/${difficulty}`, score);
}
/**
 * Call "Delete Chart Score" API.
 * @see https://github.com/ddradar/ddradar/tree/master/api/scores__id__style__diff--delete/
 */
export function deleteChartScore($http, songId, playStyle, difficulty) {
    return $http.delete(`/api/v1/scores/${songId}/${playStyle}/${difficulty}`);
}
/**
 * Call "Post Song Scores" API.
 * @see https://github.com/ddradar/ddradar/tree/master/api/scores__id--post/
 */
export function postSongScores($http, songId, scores) {
    return $http.$post(`${apiPrefix}/scores/${songId}`, scores);
}
